import { affiliateApi, brandApi } from "@/lib/axios";
import type {
  ResourceResponse,
  ResourceFormData,
  PaginatedResourceResponse,
} from "../types/resource";

export const resourceService = {
  // Get all resources for a brand with pagination
  async getBrandResourcesForAffiliates(
    sessionId: string,
    page: number = 1,
    limit: number = 20
  ): Promise<PaginatedResourceResponse> {
    try {
      const response = await affiliateApi.get(
        `/resources/affiliate/${sessionId}?page=${page}&limit=${limit}`
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching brand resources:", error);
      throw error;
    }
  },

  async getResourcesForBrand(
    page: number = 1,
    limit: number = 20
  ): Promise<PaginatedResourceResponse> {
    try {
      const response = await brandApi.get(
        `/resources/brand?page=${page}&limit=${limit}`
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching brand resources:", error);
      throw error;
    }
  },

  // Create a new resource
  async createResource(
    resourceData: ResourceFormData
  ): Promise<ResourceResponse> {
    try {
      const response = await brandApi.post(`resources`, resourceData);
      return response.data;
    } catch (error) {
      console.error("Error creating resource:", error);
      throw error;
    }
  },

  // Update an existing resource
  async updateResource(
    resourceId: string,
    resourceData: Partial<ResourceFormData>
  ): Promise<ResourceResponse> {
    try {
      const response = await brandApi.patch(
        `/resources/${resourceId}`,
        resourceData
      );
      return response.data;
    } catch (error) {
      console.error("Error updating resource:", error);
      throw error;
    }
  },

  // Delete a resource
  async deleteResource(resourceId: string): Promise<void> {
    try {
      await brandApi.delete(`/resources/${resourceId}`);
    } catch (error) {
      console.error("Error deleting resource:", error);
      throw error;
    }
  },

  // Get a single resource by ID
  async getResourceForBrand(resourceId: string): Promise<ResourceResponse> {
    try {
      const response = await brandApi.get(`/resource/${resourceId}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching resource:", error);
      throw error;
    }
  },

  async getResourceForAffiliate(resourceId: string): Promise<ResourceResponse> {
    try {
      const response = await affiliateApi.get(`/resource/${resourceId}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching resource:", error);
      throw error;
    }
  },

  // Format date for display
  formatDate(dateString: string): string {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  },
};
